import { EventEmitter } from "events"

const NoticeEmitter = new EventEmitter()

export default NoticeEmitter